import './FilterOptionItem.scss';

import type { FilterOptionType } from '@providers/FilterProvider';
import { isMultiSelectOptionItemByDefault } from '@providers/FilterProvider';
import { appendClassNames, createClsNameMap } from '@utils';
import { pick } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { createElement, forwardRef } from 'react';

export const clsNameMap = createClsNameMap()('filter-option-item');

export type FilterOptionItemSettings = Pick<
  FilterOptionType,
  'prefix' | 'displayAllValuesInUppercaseForm' | 'selectType' | 'swatchStyle'
>;

export type FilterOptionItemProps = PropsWithChildren<{
  as?: string;
  className?: string;
  style?: React.CSSProperties;
}>;

export const filterOptionItemSettings = (option: FilterOptionType): FilterOptionItemSettings => {
  const { filterType } = option;
  const optionItemSettings = pick(
    option,
    'prefix',
    'displayAllValuesInUppercaseForm',
    'selectType',
    'swatchStyle'
  );

  if (isMultiSelectOptionItemByDefault(filterType)) {
    optionItemSettings.selectType = 'multiple';
  }

  return optionItemSettings;
};

export const FilterOptionItem = forwardRef(
  ({ className, children, as = 'li', style }: FilterOptionItemProps, ref) => {
    return createElement(as, {
      className: appendClassNames(clsNameMap.root(), className),
      ref,
      style,
      children,
    });
  }
);

export * from './hooks';
